import { render, staticRenderFns } from "./CommonMng.vue?vue&type=template&id=53aeadec&"
import script from "./CommonMng.vue?vue&type=script&lang=js&"
export * from "./CommonMng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports